export * from './agreements.contract.js';
export * from './company-profile.contract.js';
export * from './ai.contract.js';
export * from './announcement.contract.js';
export * from './celebrations.contract.js';
export * from './attendance.contract.js';
export * from './audit.contract.js';
export * from './engagement-insights.contract.js';
export * from './billing.contract.js';
export * from './careers.contract.js';
export * from './chat.contract.js';
export * from './company-policy.contract.js';
export * from './clockout.contract.js';
export * from './helpdesk.contract.js';
export * from './delegation.contract.js';
export * from './directory.contract.js';
export * from './document-parse.contract.js';
export * from './document-tasks.contract.js';
export * from './employee.contract.js';
export * from './employee-transfer.contract.js';
export * from './expense.contract.js';
export * from './expense-report.contract.js';
export * from './expense-multiline-report.contract.js';
export * from './expense-comment.contract.js';
export * from './travel-request.contract.js';
export * from './travel-desk.contract.js';
export * from './travel-policy.contract.js';
export * from './travel-report.contract.js';
export * from './travel-settlement.contract.js';
export * from './fanout.contract.js';
export * from './inbox.contract.js';
export * from './biometric-device.contract.js';
export * from './integrations.contract.js';
export * from './app-integrations.contract.js';
export * from './leave.contract.js';
export * from './leave-balance-admin.contract.js';
export * from './leave-encashment.contract.js';
export * from './leave-plans.contract.js';
export * from './leave-reports.contract.js';
export * from './leave-changes.contract.js';
export * from './learning.contract.js';
export * from './goal.contract.js';
export * from './goal-template.contract.js';
export * from './feedback.contract.js';
export * from './peer-nomination.contract.js';
export * from './recognition.contract.js';
export * from './social.contract.js';
export * from './announcement-comments.contract.js';
export * from './skill.contract.js';
export * from './one-on-one.contract.js';
export * from './lookup.contract.js';
export * from './audit-log.contract.js';
export * from './my-documents.contract.js';
export * from './asset-configuration.contract.js';
export * from './vendor.contract.js';
export * from './asset-batch.contract.js';
export * from './asset-history.contract.js';
export * from './asset-custom-fields.contract.js';
export * from './asset-audit.contract.js';
export * from './asset-handover.contract.js';
export * from './asset-depreciation.contract.js';
export * from './asset-register-ext.contract.js';
export * from './review.contract.js';
export * from './review-cycle.contract.js';
export * from './competency.contract.js';
export * from './calibration.contract.js';
export * from './improvement-plan.contract.js';
export * from './merit.contract.js';
export * from './performance-dashboard.contract.js';
export * from './performance-trends.contract.js';
export * from './performance-insights.contract.js';
export * from './notification-email-mute.contract.js';
export * from './signup-lead.contract.js';
export * from './notification-settings.contract.js';
export * from './email-settings.contract.js';
export * from './whatsapp-settings.contract.js';
export * from './email-templates.contract.js';
export * from './notifications.contract.js';
export * from './organisation.contract.js';
export * from './org-setup.contract.js';
export * from './people-analytics.contract.js';
export * from './employee-custom-fields.contract.js';
export * from './employee-field-sections.contract.js';
export * from './setup-status.contract.js';
export * from './company-group.contract.js';
export * from './company-group-policy.contract.js';
export * from './group-learning.contract.js';
export * from './probation-policies.contract.js';
export * from './org-import.contract.js';
export * from './employee-number-series.contract.js';
export * from './payroll-calendar.contract.js';
export * from './payroll-compensation.contract.js';
export * from './payroll-merit.contract.js';
export * from './payroll-merit-settings.contract.js';
export * from './payroll-settings.contract.js';
export * from './payroll-loans.contract.js';
export * from './payroll-inputs.contract.js';
export * from './payroll-ewa.contract.js';
export * from './payroll-tax.contract.js';
export * from './payroll-fbp-declaration.contract.js';
export * from './payroll-runs.contract.js';
export * from './payroll-lifecycle.contract.js';
export * from './payroll-payslips.contract.js';
export * from './payroll-payments.contract.js';
export * from './payroll-fnf.contract.js';
export * from './payroll-compliance.contract.js';
export * from './payroll-reports.contract.js';
export * from './payroll-queries.contract.js';
export * from './payroll-rules.contract.js';
export * from './payroll-rollout.contract.js';
export * from './onboarding.contract.js';
export * from './probation.schemas.js';
export * from './personal-details.contract.js';
export * from './offboarding.contract.js';
export * from './project.contract.js';
export * from './timesheet.contract.js';
export * from './workform.contract.js';
export * from './platform.contract.js';
export * from './platform-notifications.contract.js';
export * from './recruitment.contract.js';
export * from './roles.contract.js';
export * from './salary-pin.contract.js';
export * from './search.contract.js';
export * from './survey.contract.js';
export * from './training.contract.js';
export * from './training-live.contract.js';
export * from './workflow-definitions.contract.js';
/**
 * The root contract.
 *
 * One object, so a client is constructed once and every route on it is reachable and typed. As
 * feature contracts land they are added here rather than exported separately — a second client for
 * a second contract means two base URLs, two auth interceptors, and two places for a refresh bug
 * to hide.
 *
 * `goals`/`objectives` are two separate entries, not one nested `performance` group — `goalContract`
 * and `objectiveContract` are already flat top-level routers (see goal.contract.ts's header:
 * `tsRestRouter` throws on nesting), and the root contract mirrors that shape 1:1.
 */

import { initContract, type AppRoute, type AppRouter } from '@ts-rest/core';
import { agreementContract } from './agreements.contract.js';
import { companyProfileContract } from './company-profile.contract.js';
import { aiContract } from './ai.contract.js';
import { announcementContract } from './announcement.contract.js';
import { celebrationsContract } from './celebrations.contract.js';
import { attendanceContract } from './attendance.contract.js';
import { engagementInsightsContract } from './engagement-insights.contract.js';
import { auditContract } from './audit.contract.js';
import { authContract } from './auth.contract.js';
import { billingContract } from './billing.contract.js';
import { careersContract } from './careers.contract.js';
import { chatContract } from './chat.contract.js';
import { companyPolicyContract } from './company-policy.contract.js';
import { clockoutContract } from './clockout.contract.js';
import { helpdeskContract } from './helpdesk.contract.js';
import { delegationContract } from './delegation.contract.js';
import { directoryContract } from './directory.contract.js';
import { documentParseContract } from './document-parse.contract.js';
import { documentTaskContract } from './document-tasks.contract.js';
import { employeeContract } from './employee.contract.js';
import { expenseContract } from './expense.contract.js';
import { expenseReportContract } from './expense-report.contract.js';
import { expenseMultilineReportContract } from './expense-multiline-report.contract.js';
import { expenseCommentContract } from './expense-comment.contract.js';
import { travelRequestContract } from './travel-request.contract.js';
import { travelDeskContract } from './travel-desk.contract.js';
import { travelPolicyContract } from './travel-policy.contract.js';
import { travelReportContract } from './travel-report.contract.js';
import { travelSettlementContract } from './travel-settlement.contract.js';
import { assetContract } from './asset.contract.js';
import { biometricDeviceContract } from './biometric-device.contract.js';
import { inboxContract } from './inbox.contract.js';
import { integrationsContract, zohoIntegrationContract } from './integrations.contract.js';
import {
  publicTrainingJoinContract,
  trainingLiveSessionsContract,
} from './training-live.contract.js';
import { appIntegrationsContract } from './app-integrations.contract.js';
import { leaveContract } from './leave.contract.js';
import { leaveBalanceAdminContract } from './leave-balance-admin.contract.js';
import { leaveEncashmentContract } from './leave-encashment.contract.js';
import { leavePlansContract } from './leave-plans.contract.js';
import { leaveReportsContract } from './leave-reports.contract.js';
import { leaveChangesContract } from './leave-changes.contract.js';
import { learningContract } from './learning.contract.js';
import { goalContract, objectiveContract } from './goal.contract.js';
import { goalTemplateContract } from './goal-template.contract.js';
import { feedbackContract } from './feedback.contract.js';
import { peerNominationContract } from './peer-nomination.contract.js';
import { recognitionContract, recognitionCertificateContract } from './recognition.contract.js';
import { socialContract } from './social.contract.js';
import { announcementCommentsContract } from './announcement-comments.contract.js';
import { oneOnOneContract } from './one-on-one.contract.js';
import { lookupContract } from './lookup.contract.js';
import { auditLogContract } from './audit-log.contract.js';
import { myDocumentsContract } from './my-documents.contract.js';
import { assetConfigurationContract } from './asset-configuration.contract.js';
import { vendorContract } from './vendor.contract.js';
import { assetBatchContract } from './asset-batch.contract.js';
import { assetHistoryContract } from './asset-history.contract.js';
import { assetCustomFieldsContract } from './asset-custom-fields.contract.js';
import { assetAuditContract } from './asset-audit.contract.js';
import { assetHandoverContract } from './asset-handover.contract.js';
import { assetDepreciationContract } from './asset-depreciation.contract.js';
import { assetRegisterExtContract } from './asset-register-ext.contract.js';
import { reviewContract } from './review.contract.js';
import { reviewCycleContract } from './review-cycle.contract.js';
import { competencyContract } from './competency.contract.js';
import { skillContract } from './skill.contract.js';
import { calibrationContract } from './calibration.contract.js';
import { improvementPlanContract } from './improvement-plan.contract.js';
import { meritContract } from './merit.contract.js';
import { performanceDashboardContract } from './performance-dashboard.contract.js';
import { performanceTrendsContract } from './performance-trends.contract.js';
import { performanceInsightsContract } from './performance-insights.contract.js';
import { notificationSettingsContract } from './notification-settings.contract.js';
import { notificationEmailMuteContract } from './notification-email-mute.contract.js';
import { signupLeadContract } from './signup-lead.contract.js';
import { emailSettingsContract } from './email-settings.contract.js';
import { whatsappSettingsContract } from './whatsapp-settings.contract.js';
import { emailTemplatesContract } from './email-templates.contract.js';
import { notificationsContract } from './notifications.contract.js';
import { organisationContract } from './organisation.contract.js';
import { orgSetupContract } from './org-setup.contract.js';
import { peopleAnalyticsContract } from './people-analytics.contract.js';
import { employeeCustomFieldsContract } from './employee-custom-fields.contract.js';
import { employeeFieldSectionsContract } from './employee-field-sections.contract.js';
import { setupStatusContract } from './setup-status.contract.js';
import { companyGroupContract } from './company-group.contract.js';
import { companyGroupPolicyContract } from './company-group-policy.contract.js';
import { groupLearningContract } from './group-learning.contract.js';
import { probationPoliciesContract } from './probation-policies.contract.js';
import { orgImportContract } from './org-import.contract.js';
import { employeeNumberSeriesContract } from './employee-number-series.contract.js';
import { payrollCalendarContract } from './payroll-calendar.contract.js';
import { payrollCompensationContract } from './payroll-compensation.contract.js';
import { payrollMeritContract } from './payroll-merit.contract.js';
import { payrollMeritSettingsContract } from './payroll-merit-settings.contract.js';
import { payrollSettingsContract } from './payroll-settings.contract.js';
import { payrollLoansContract } from './payroll-loans.contract.js';
import { payrollInputsContract } from './payroll-inputs.contract.js';
import { payrollEwaContract } from './payroll-ewa.contract.js';
import { payrollTaxContract } from './payroll-tax.contract.js';
import { payrollFbpDeclarationContract } from './payroll-fbp-declaration.contract.js';
import { payrollRunsContract } from './payroll-runs.contract.js';
import { payrollLifecycleContract } from './payroll-lifecycle.contract.js';
import { payrollPayslipsContract } from './payroll-payslips.contract.js';
import { payrollPaymentsContract } from './payroll-payments.contract.js';
import { payrollFnfContract } from './payroll-fnf.contract.js';
import { payrollComplianceContract } from './payroll-compliance.contract.js';
import { payrollReportsContract } from './payroll-reports.contract.js';
import { payrollQueriesContract } from './payroll-queries.contract.js';
import { payrollRolloutContract } from './payroll-rollout.contract.js';
import { payrollRulePacksContract, payrollRulesContract } from './payroll-rules.contract.js';
import { onboardingContract } from './onboarding.contract.js';
import { platformContract } from './platform.contract.js';
import { platformNotificationsContract } from './platform-notifications.contract.js';
import { personalDetailsContract } from './personal-details.contract.js';
import { offboardingContract } from './offboarding.contract.js';
import { projectContract } from './project.contract.js';
import { recruitmentContract } from './recruitment.contract.js';
import { timesheetContract } from './timesheet.contract.js';
import { workformContract } from './workform.contract.js';
import { rolesContract } from './roles.contract.js';
import { salaryPinContract } from './salary-pin.contract.js';
import { searchContract } from './search.contract.js';
import {
  surveyContract,
  surveyTemplateContract,
  surveyRecurrenceContract,
} from './survey.contract.js';
import {
  trainingMeContract,
  trainingAssignmentsContract,
  trainingTasksContract,
  trainingSessionsContract,
  trainingQuizAttemptsContract,
  trainingAdminContract,
  trainingCategoriesContract,
  trainingBatchesContract,
  trainingCertificatesContract,
  publicCertificatesContract,
  trainingAnalyticsContract,
  trainingLearnerContract,
  trainingCoursesContract,
  trainingLegacyAssignmentsContract,
  trainingCertificateTemplatesContract,
  trainingCertificateIssuesContract,
  trainingExternalCertificatesContract,
} from './training.contract.js';
import { workflowDefinitionsContract } from './workflow-definitions.contract.js';

const c = initContract();

/**
 * Explicit type annotation, deliberately: as this root contract grew (goals/reviews/insights from
 * one branch, expense/attendance/onboarding/recruitment/roles from another — see the merge that
 * combined them), the plain inferred type of `c.router({...})` exceeds TypeScript's
 * type-serialization limit (TS7056) the moment it's exported — see `apps/web/src/lib/api.ts` and
 * `packages/api-client/src/react-query.ts` for the same fix applied at their own call sites, one
 * layer downstream of this one. Naming the shape here keeps the error where it's actually caused.
 */
interface RootContract {
  agreements: typeof agreementContract;
  companyProfile: typeof companyProfileContract;
  ai: typeof aiContract;
  announcements: typeof announcementContract;
  celebrations: typeof celebrationsContract;
  attendance: typeof attendanceContract;
  audit: typeof auditContract;
  engagementInsights: typeof engagementInsightsContract;
  auth: typeof authContract;
  billing: typeof billingContract;
  careers: typeof careersContract;
  chat: typeof chatContract;
  companyPolicies: typeof companyPolicyContract;
  clockOutPolicy: typeof clockoutContract;
  surveys: typeof surveyContract;
  surveyTemplates: typeof surveyTemplateContract;
  surveyRecurrences: typeof surveyRecurrenceContract;
  delegation: typeof delegationContract;
  directory: typeof directoryContract;
  employees: typeof employeeContract;
  expense: typeof expenseContract;
  expenseReports: typeof expenseReportContract;
  expenseMultilineReport: typeof expenseMultilineReportContract;
  expenseComments: typeof expenseCommentContract;
  travelRequest: typeof travelRequestContract;
  travelDesk: typeof travelDeskContract;
  travelPolicy: typeof travelPolicyContract;
  travelReports: typeof travelReportContract;
  travelSettlement: typeof travelSettlementContract;
  helpdesk: typeof helpdeskContract;
  asset: typeof assetContract;
  biometricDevice: typeof biometricDeviceContract;
  inbox: typeof inboxContract;
  integrations: typeof integrationsContract;
  zohoIntegration: typeof zohoIntegrationContract;
  appIntegrations: typeof appIntegrationsContract;
  leave: typeof leaveContract;
  leaveBalances: typeof leaveBalanceAdminContract;
  leaveEncashment: typeof leaveEncashmentContract;
  leavePlans: typeof leavePlansContract;
  leaveReports: typeof leaveReportsContract;
  leaveChanges: typeof leaveChangesContract;
  learningAssignments: typeof learningContract;
  goals: typeof goalContract;
  objectives: typeof objectiveContract;
  goalTemplates: typeof goalTemplateContract;
  feedback: typeof feedbackContract;
  peerNominations: typeof peerNominationContract;
  recognition: typeof recognitionContract;
  recognitionCertificates: typeof recognitionCertificateContract;
  // Engage › Social wall (posts, comments, @mentions, reactions). Gated under the `chat`
  // module entitlement, same as announcementComments below — no separate `social` module.
  social: typeof socialContract;
  announcementComments: typeof announcementCommentsContract;
  oneOnOnes: typeof oneOnOneContract;
  lookup: typeof lookupContract;
  auditLogs: typeof auditLogContract;
  // Asset Configuration (Categories/Types) and Vendors — the Administration screens under Asset
  // Management. Separate from `asset` (assetContract, pathPrefix /asset): that's the asset
  // register/request/custody lifecycle; these are the classification-and-supplier admin layer
  // over it, with no route-path or model overlap by design — see each contract's own header.
  assetConfiguration: typeof assetConfigurationContract;
  vendors: typeof vendorContract;
  // Asset Batches — the Administration screens' 3rd tab. A separate router (not folded into
  // `assetConfiguration`) since it has its own path prefix and permission axis (asset.batch:*);
  // its routes reference `asset.contract.ts`'s existing `Asset` register via `Asset.batchId`
  // rather than defining a competing asset shape.
  assetBatches: typeof assetBatchContract;
  // History & Reports (AST-2) — Administration's 4th tab. The org-wide, filterable, paginated
  // equivalent of asset.contract.ts's single-asset `getAssetHistory`, plus its CSV export. Its own
  // router for the same reason as assetBatches above: a distinct path prefix, and no data model of
  // its own (reads asset.contract.ts's existing `AssetHistory` rows).
  assetHistory: typeof assetHistoryContract;
  // Asset custom fields per category (AST-12): Asset-specific contract over the generic custom-field
  // infrastructure in ../custom-fields/. Own router; same /asset-management prefix, distinct paths.
  assetCustomFields: typeof assetCustomFieldsContract;
  // Physical asset audits (AST-23) — runs, per-asset checklist, scan, close + discrepancy report.
  assetAudits: typeof assetAuditContract;
  // Exit recovery + onboarding handover (AST-6 / AST-13), depreciation (AST-20) and register
  // extensions — export, department/location custody, vendor and legal-entity links (AST-24..27).
  assetHandover: typeof assetHandoverContract;
  assetDepreciation: typeof assetDepreciationContract;
  assetRegisterExt: typeof assetRegisterExtContract;
  reviews: typeof reviewContract;
  reviewCycles: typeof reviewCycleContract;
  competencies: typeof competencyContract;
  skills: typeof skillContract;
  calibrationSessions: typeof calibrationContract;
  improvementPlans: typeof improvementPlanContract;
  merit: typeof meritContract;
  performanceDashboard: typeof performanceDashboardContract;
  performanceTrends: typeof performanceTrendsContract;
  performanceInsights: typeof performanceInsightsContract;
  notificationSettings: typeof notificationSettingsContract;
  notificationEmailMute: typeof notificationEmailMuteContract;
  signupLead: typeof signupLeadContract;
  emailSettings: typeof emailSettingsContract;
  whatsappSettings: typeof whatsappSettingsContract;
  emailTemplates: typeof emailTemplatesContract;
  notifications: typeof notificationsContract;
  organisation: typeof organisationContract;
  orgSetup: typeof orgSetupContract;
  peopleAnalytics: typeof peopleAnalyticsContract;
  employeeCustomFields: typeof employeeCustomFieldsContract;
  employeeFieldSections: typeof employeeFieldSectionsContract;
  setupStatus: typeof setupStatusContract;
  companyGroup: typeof companyGroupContract;
  companyGroupPolicies: typeof companyGroupPolicyContract;
  // Group learning (ADR 0036): the all-companies course library, copy/assign runs and live-session calendar.
  groupLearning: typeof groupLearningContract;
  probationPolicies: typeof probationPoliciesContract;
  orgImport: typeof orgImportContract;
  employeeNumberSeries: typeof employeeNumberSeriesContract;
  payrollCalendar: typeof payrollCalendarContract;
  payrollCompensation: typeof payrollCompensationContract;
  payrollMerit: typeof payrollMeritContract;
  payrollMeritSettings: typeof payrollMeritSettingsContract;
  payrollSettings: typeof payrollSettingsContract;
  payrollLoans: typeof payrollLoansContract;
  payrollInputs: typeof payrollInputsContract;
  payrollEwa: typeof payrollEwaContract;
  payrollTax: typeof payrollTaxContract;
  payrollFbpDeclaration: typeof payrollFbpDeclarationContract;
  payrollRuns: typeof payrollRunsContract;
  payrollLifecycle: typeof payrollLifecycleContract;
  payrollPayslips: typeof payrollPayslipsContract;
  payrollPayments: typeof payrollPaymentsContract;
  payrollFnf: typeof payrollFnfContract;
  payrollCompliance: typeof payrollComplianceContract;
  payrollReports: typeof payrollReportsContract;
  payrollQueries: typeof payrollQueriesContract;
  payrollRollout: typeof payrollRolloutContract;
  payrollRules: typeof payrollRulesContract;
  payrollRulePacks: typeof payrollRulePacksContract;
  onboarding: typeof onboardingContract;
  platform: typeof platformContract;
  platformNotifications: typeof platformNotificationsContract;
  documentParse: typeof documentParseContract;
  documentTasks: typeof documentTaskContract;
  myDocuments: typeof myDocumentsContract;
  personalDetails: typeof personalDetailsContract;
  offboarding: typeof offboardingContract;
  recruitment: typeof recruitmentContract;
  roles: typeof rolesContract;
  // The salary PIN (ADR 0041): set / enter / change / reset the PIN that unlocks other people's pay.
  salaryPin: typeof salaryPinContract;
  search: typeof searchContract;
  workflowDefinitions: typeof workflowDefinitionsContract;
  projects: typeof projectContract;
  timesheets: typeof timesheetContract;
  workForms: typeof workformContract;
  // Training (Training_Module_Plan.md §3) — the employee side (`trainingMe`, `trainingAssignments`,
  // `trainingSessions`, `trainingQuizAttempts`), the manager/HR side (`trainingTasks` library
  // authoring, `trainingCategories`, `trainingBatches`, `trainingAdmin` monitor/policy), and the
  // Phase 2A Keka-parity layer (`trainingCertificates` + the genuinely public
  // `publicCertificates`, `trainingAnalytics`). One router per `pathPrefix`, matching every other
  // feature area in this file.
  trainingMe: typeof trainingMeContract;
  trainingAssignments: typeof trainingAssignmentsContract;
  trainingTasks: typeof trainingTasksContract;
  trainingSessions: typeof trainingSessionsContract;
  trainingQuizAttempts: typeof trainingQuizAttemptsContract;
  trainingAdmin: typeof trainingAdminContract;
  trainingCategories: typeof trainingCategoriesContract;
  trainingBatches: typeof trainingBatchesContract;
  trainingCertificates: typeof trainingCertificatesContract;
  publicCertificates: typeof publicCertificatesContract;
  trainingAnalytics: typeof trainingAnalyticsContract;
  // Training redesign (docs/plans/training-redesign): My learning + My team, the course page's
  // Learners tab / reminders / embed lookup / strict review, and the older "Learning & Training"
  // items' HR list and convert-to-course.
  trainingLearner: typeof trainingLearnerContract;
  trainingCourses: typeof trainingCoursesContract;
  trainingLegacyAssignments: typeof trainingLegacyAssignmentsContract;
  // Certificates (training redesign PLAN §13): designs, issued certificates (list/reissue/history),
  // and external certificates HR uploads for a person.
  trainingCertificateTemplates: typeof trainingCertificateTemplatesContract;
  trainingCertificateIssues: typeof trainingCertificateIssuesContract;
  trainingExternalCertificates: typeof trainingExternalCertificatesContract;
  // Live (instructor-led) sessions over Zoho Meeting or a pasted link, plus the public personal
  // join link. See training-live.contract.ts.
  trainingLiveSessions: typeof trainingLiveSessionsContract;
  publicTrainingJoin: typeof publicTrainingJoinContract;
  // Structural, not semantic: ts-rest's `AppRouter` constraint requires an index signature, and a
  // named-property interface doesn't get one for free.
  [key: string]: AppRouter | AppRoute;
}

export const contract: RootContract = c.router({
  agreements: agreementContract,
  companyProfile: companyProfileContract,
  ai: aiContract,
  // Engage › Announcements (ADR 0029). Not chat broadcasts, not company policies.
  announcements: announcementContract,
  // Engage › Celebrations — read-only birthdays/work-anniversaries feed. No wishes/comments (by
  // design, same call as skipping a manual "Send Nudge" elsewhere in Engage).
  celebrations: celebrationsContract,
  attendance: attendanceContract,
  audit: auditContract,
  // Engage › org-wide analytics rollup across announcements and surveys — no new data of its own.
  engagementInsights: engagementInsightsContract,
  auth: authContract,
  billing: billingContract,
  careers: careersContract,
  chat: chatContract,
  // Company policies — the handbook employees read and acknowledge (ADR 0026). Not leave policies,
  // not the payroll company-policy layer (ADR 0016).
  companyPolicies: companyPolicyContract,
  // Clock-out readiness gate (ADR 0019): policy config plus a self-serve readiness read, separate
  // from the punch route itself so the web app can show blockers before an attempt, not only after.
  clockOutPolicy: clockoutContract,
  surveys: surveyContract,
  surveyTemplates: surveyTemplateContract,
  surveyRecurrences: surveyRecurrenceContract,
  delegation: delegationContract,
  directory: directoryContract,
  // The service desk: tickets, teams, SLAs and satisfaction (ADR 0028).
  helpdesk: helpdeskContract,
  documentParse: documentParseContract,
  documentTasks: documentTaskContract,
  myDocuments: myDocumentsContract,
  employees: employeeContract,
  expense: expenseContract,
  expenseReports: expenseReportContract,
  expenseMultilineReport: expenseMultilineReportContract,
  expenseComments: expenseCommentContract,
  // Travel requests (R-P10): the base request/approval + booking-status tracker.
  travelRequest: travelRequestContract,
  // Travel Desk (ADR 0030), extending travelRequest above: three flat routers, distinct first
  // path segments — `/travel/desk` (the desk queue), `/travel/admin` (policy) and
  // `/travel/reports`. Keys matter: the copilot derives tool names from them.
  travelDesk: travelDeskContract,
  travelPolicy: travelPolicyContract,
  travelReports: travelReportContract,
  // The money of a trip (Phase 4): advances, trip-linked claims, allowance drafts, settlement
  // rounds, net-off, recovery and write-off. `/travel/money`.
  travelSettlement: travelSettlementContract,
  asset: assetContract,
  biometricDevice: biometricDeviceContract,
  inbox: inboxContract,
  integrations: integrationsContract,
  zohoIntegration: zohoIntegrationContract,
  // Settings -> Integrations -> Applications (ADR 0033): employees created in outside applications.
  appIntegrations: appIntegrationsContract,
  leave: leaveContract,
  // HR's balance register, adjustments (single and bulk CSV) and the balance ledger read. Same
  // `/leave` prefix, no path overlap with `leave` — see the contract's header.
  leaveBalances: leaveBalanceAdminContract,
  // Leave encashment policy, HR's year-end runs and the employee's encashment requests (ADR 0031).
  // Same `/leave` prefix, no path overlap with `leave` or `leaveBalances`.
  leaveEncashment: leaveEncashmentContract,
  // Same `/leave` prefix, no path overlap with `leave`, `leaveBalances` or `leaveEncashment`.
  leavePlans: leavePlansContract,
  // Leave reports (register, lapses, trends, loss of pay) and the holiday bulk import. Same `/leave`
  // prefix, paths under `/reports/*` and `/holidays/import/*` — no overlap with the routers above.
  leaveReports: leaveReportsContract,
  // Comp-off requests, cancellation requests and amendments of approved leave (ADR 0031 addendum,
  // Phase 4b). Same `/leave` prefix; paths under `/comp-off-requests`, `/cancellation-requests`,
  // `/amendments` and `/requests/:leaveRequestId/amend` — no overlap with the routers above.
  leaveChanges: leaveChangesContract,
  // Mandatory learning assignments (ADR 0019) — backs the existing, previously-unused
  // learning:read/learning:manage/learning.assign:execute permissions.
  learningAssignments: learningContract,
  goals: goalContract,
  objectives: objectiveContract,
  goalTemplates: goalTemplateContract,
  feedback: feedbackContract,
  peerNominations: peerNominationContract,
  recognition: recognitionContract,
  recognitionCertificates: recognitionCertificateContract,
  social: socialContract,
  announcementComments: announcementCommentsContract,
  oneOnOnes: oneOnOneContract,
  lookup: lookupContract,
  auditLogs: auditLogContract,
  assetConfiguration: assetConfigurationContract,
  vendors: vendorContract,
  assetBatches: assetBatchContract,
  assetHistory: assetHistoryContract,
  assetCustomFields: assetCustomFieldsContract,
  assetAudits: assetAuditContract,
  assetHandover: assetHandoverContract,
  assetDepreciation: assetDepreciationContract,
  assetRegisterExt: assetRegisterExtContract,
  // Performance Reviews (Section 4) — three flat routers, never nested into one another or under
  // a `performance` group, matching goals/objectives' precedent (tsRestRouter rejects nesting).
  reviews: reviewContract,
  reviewCycles: reviewCycleContract,
  competencies: competencyContract,
  skills: skillContract,
  calibrationSessions: calibrationContract,
  improvementPlans: improvementPlanContract,
  // Merit & Compensation Planning (PRF-9/PRF-29) — the increment matrix, per-employee
  // recommendations, the manager worksheet, and HR's decision through the existing
  // merit_cycle_budget workflow entity type (never a second approval mechanism).
  merit: meritContract,
  // Performance Dashboard (Section 1) — the home/overview layer. Zero data model of its own; every
  // field is an aggregate over the routers above (+ Section 5's trend endpoint, once that section
  // lands — see the Dashboard plan's addendum for why this section doesn't wait on it).
  performanceDashboard: performanceDashboardContract,
  // Performance Trends (Section 5, partial) — goal momentum + recognition/feedback activity
  // aggregates that no existing endpoint can serve (see this router's file header for why).
  // Contract only for now; the route lands in a follow-up PR.
  performanceTrends: performanceTrendsContract,
  // Performance Insights (Section 5 / plan Phase 3) — the filtered org analytics view at
  // /performance/insights: rating distribution, team/department breakdown, cycle completion, and
  // an attention list, each k-anonymity-safe where the response is a score aggregate. Contract
  // only for now; permission + route + k-anonymity tests land in follow-up PRs.
  performanceInsights: performanceInsightsContract,
  notificationSettings: notificationSettingsContract,
  notificationEmailMute: notificationEmailMuteContract,
  signupLead: signupLeadContract,
  emailSettings: emailSettingsContract,
  whatsappSettings: whatsappSettingsContract,
  emailTemplates: emailTemplatesContract,
  notifications: notificationsContract,
  organisation: organisationContract,
  // Grades, cost centres and employee groups (ADR 0022). Same `/organisation` prefix, no path overlap.
  orgSetup: orgSetupContract,
  peopleAnalytics: peopleAnalyticsContract,
  employeeCustomFields: employeeCustomFieldsContract,
  employeeFieldSections: employeeFieldSectionsContract,
  setupStatus: setupStatusContract,
  // Company groups (ADR 0034): create another company, Group access, link at sign-up.
  companyGroup: companyGroupContract,
  // Group policies (ADR 0037): publish and manage company policies across the group's companies.
  companyGroupPolicies: companyGroupPolicyContract,
  groupLearning: groupLearningContract,
  probationPolicies: probationPoliciesContract,
  orgImport: orgImportContract,
  // Employee ID series (prefix / padding / next number per legal entity).
  employeeNumberSeries: employeeNumberSeriesContract,
  payrollCalendar: payrollCalendarContract,
  payrollCompensation: payrollCompensationContract,
  // Applying approved merit proposals to pay (remediation plan §16, D2/Q8): the payroll admin's
  // "Pending merit revisions" queue and the apply action. Two-reviewer area.
  payrollMerit: payrollMeritContract,
  payrollMeritSettings: payrollMeritSettingsContract,
  payrollSettings: payrollSettingsContract,
  payrollLoans: payrollLoansContract,
  payrollInputs: payrollInputsContract,
  payrollEwa: payrollEwaContract,
  payrollTax: payrollTaxContract,
  payrollFbpDeclaration: payrollFbpDeclarationContract,
  payrollRuns: payrollRunsContract,
  payrollLifecycle: payrollLifecycleContract,
  // Payslip release (ADR 0015): versioned publications against the final result, the publication
  // policy, and private download links. Contract only; the routes land in a follow-up.
  payrollPayslips: payrollPayslipsContract,
  // Payment batches, obligations, attempts, salary holds and off-cycle payments (ADR 0015): prepare,
  // authorise, transmit/export, reconcile. Contract only; the routes land in a follow-up.
  payrollPayments: payrollPaymentsContract,
  // Full & Final settlement (ADR 0015): calculation versions and items, exit clearances, and the
  // approvals that bind to an exact version. Extends the existing `/employees/fnf-settlements`
  // routes (kept, unchanged) rather than replacing them. Contract only; the routes land in a
  // follow-up.
  payrollFnf: payrollFnfContract,
  // Compliance & tax documents, Reports & Accounts, and the salary-query desk. Three flat routers
  // rather than one `payrollCompliance` group, matching every other payroll router here — and
  // because they answer to different permissions: a finance role holds the ledger and the period
  // close, an HR desk holds the queries, and neither implies the other.
  payrollCompliance: payrollComplianceContract,
  payrollReports: payrollReportsContract,
  payrollQueries: payrollQueriesContract,
  payrollRollout: payrollRolloutContract,
  payrollRules: payrollRulesContract,
  payrollRulePacks: payrollRulePacksContract,
  onboarding: onboardingContract,
  platform: platformContract,
  platformNotifications: platformNotificationsContract,
  personalDetails: personalDetailsContract,
  offboarding: offboardingContract,
  projects: projectContract,
  recruitment: recruitmentContract,
  timesheets: timesheetContract,
  workForms: workformContract,
  roles: rolesContract,
  salaryPin: salaryPinContract,
  search: searchContract,
  trainingMe: trainingMeContract,
  trainingAssignments: trainingAssignmentsContract,
  trainingTasks: trainingTasksContract,
  trainingSessions: trainingSessionsContract,
  trainingQuizAttempts: trainingQuizAttemptsContract,
  trainingAdmin: trainingAdminContract,
  trainingCategories: trainingCategoriesContract,
  trainingBatches: trainingBatchesContract,
  trainingCertificates: trainingCertificatesContract,
  publicCertificates: publicCertificatesContract,
  trainingAnalytics: trainingAnalyticsContract,
  trainingLearner: trainingLearnerContract,
  trainingCourses: trainingCoursesContract,
  trainingLegacyAssignments: trainingLegacyAssignmentsContract,
  trainingCertificateTemplates: trainingCertificateTemplatesContract,
  trainingCertificateIssues: trainingCertificateIssuesContract,
  trainingExternalCertificates: trainingExternalCertificatesContract,
  trainingLiveSessions: trainingLiveSessionsContract,
  publicTrainingJoin: publicTrainingJoinContract,
  // Approval workflow definitions (ADR 0010 section 9, phase 5): list, get, save the next version,
  // validate, and coverage. Contract only in this commit; the routes land in a follow-up.
  workflowDefinitions: workflowDefinitionsContract,
});

export type Contract = typeof contract;

export * from './asset.contract.js';
export * from './auth.contract.js';
export * from './meta.js';
